import { clone, find } from 'lodash-es'

import { IInsurance } from './InsuranceModel'

export interface InsuranceQR {
  id: 'A' | 'B' | 'C'
  faqKey: string
  value: number | string | null
  currency: TInsuranceCurrency
  checked?: boolean
}

export const insuranceTypes: InsuranceQR[] = [
  {
    id: 'A',
    faqKey: 'a',
    checked: false,
    value: null,
    currency: 'EUR',
  },
  {
    id: 'B',
    faqKey: 'b',
    checked: false,
    value: null,
    currency: 'EUR',
  },
  {
    id: 'C',
    faqKey: 'c',
    checked: false,
    value: null,
    currency: 'EUR',
  },
]

export const insuranceCurrencyValues = ['EUR', 'USD']
export type TInsuranceCurrency = 'EUR' | 'USD'

export const toInsuranceQR = (sheetInsurance: IInsurance[]): InsuranceQR[] => {
  if (sheetInsurance && sheetInsurance.length > 0) {
    return insuranceTypes.map((insuranceType) => {
      const sheetInsuranceItem = find(sheetInsurance, (_insurance) => _insurance.commodityClass === insuranceType.id)

      if (sheetInsuranceItem) {
        return {
          ...insuranceType,
          value: sheetInsuranceItem.value.value,
          currency: sheetInsuranceItem.value.code as TInsuranceCurrency,
          checked: true,
        }
      }
      return { ...insuranceType, checked: false, value: null }
    })
  }
  return clone(insuranceTypes)
}

export function serializeInsuranceQR(insurance: InsuranceQR[]): IInsurance[] {
  // @ts-expect-error TS(2322) FIXME: Type '{ commodityClass: "A" | "B" | "C"; value: { ... Remove this comment to see the full error message
  return insurance
    .filter((ins) => ins.checked)
    .map((ins) => ({
      commodityClass: ins.id,
      value: {
        code: ins.currency,
        value: ins.value,
      },
    }))
}
